import { useContext, useEffect, useState } from "react"
import { AppContext } from "../../context/context"
import UiToggle2 from "../../components/ui_toogle2"
import UiButton1 from "../../components/ui_button1"
import { apiUrl } from "../../config/delcare"
import UiSpinner from "../../components/ui_spinner"

const AccountMfa = () => {

    const { ww, neonUser, setToastContent, toastInit, token } = useContext(AppContext)

    const [email, setEmail] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [mfa, setMfa] = useState("")

    const getHeaders = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${token.accessToken}`)
        return myHeaders
    }

    const showToast = (message) => {
        setToastContent(message)
        if (toastInit) toastInit.show()
    }

    const viewMfa = async () => {
        setLoading2(true)
        try {
            let url = encodeURI(`${apiUrl}/user_mfa?action=view&user_id=${neonUser.user_id}`)
            let resp = await fetch(url, {
                method: "GET",
                headers: getHeaders()
            })
            resp = await resp.json()
            if (resp.length > 0) setMfa(resp[0].type)
        }
        catch (err) {
            return
        }
        finally {
            setLoading2(false)
        }
    }

    const modifyMfa = async () => {
        setLoading(true)
        if (toastInit) toastInit.hide()

        if (email) {
            let url = encodeURI(`${apiUrl}/user_mfa?action=email&user_id=${neonUser.user_id}&email=${neonUser.email}`)
            let resp = await fetch(url, {
                method: "GET",
                headers: getHeaders()
            })
            resp = await resp.json()
            if ("error" in resp) {
                showToast(resp.error || "Something went wrong! please try again")
                setLoading(false)
                return
            }
        }
        else {
            let url = encodeURI(`${apiUrl}/user_mfa?action=delete&user_id=${neonUser.user_id}`)
            let resp = await fetch(url, {
                method: "GET",
                headers: getHeaders()
            })
            resp = await resp.json()
            if ("error" in resp) {
                showToast(resp.error || "Something went wrong! please try again")
                setLoading(false)
                return
            }
        }

        setLoading(false)
        showToast("Multifactor settings updated.")
        return
    }

    useEffect(() => {
        if (!!mfa && mfa == 'email') setEmail(true)
    }, [mfa])

    useEffect(() => {
        if (token?.accessToken) viewMfa()
    }, [token])

    return (
        <>
            <div className={"gap-3 d-flex flex-column " + (ww < 400 ? "px-3 pt-4 " : "p-4")}>
                <div className="d-flex gap-2">
                    <p className="align-self-center mb-1 fs-4">Multifactor Authentication</p>
                </div>
                <div style={{ maxWidth: 1600 }}>
                    <div className="container1">
                        {loading2 ?
                            <UiSpinner />
                            :
                            <div style={{ maxWidth: 500 }}>
                                <p className="poppins">Select Multifactor Authentication</p>
                                <div className="d-flex gap-2" onClick={() => setEmail(old => !old)}>
                                    <UiToggle2 state={email} /> <p className="poppins">Email</p>
                                </div>
                                <div style={{ width: 150 }}>
                                    {loading ?
                                        <UiSpinner />
                                        :
                                        <UiButton1 text={"Save"} width={130} submit={modifyMfa} />
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccountMfa